import { Chip } from "@mui/material";

import { TipoOperacao } from "../../../models/enum";

type Props = {
  tipoOperacao: TipoOperacao;
};

/**
 * Lado da operação → semântica de `palette.statusChip`:
 * - `destructive` → COMPRA (saída de caixa, aumenta custo médio);
 * - `positive`    → VENDA (entrada de caixa, é o que apura resultado).
 * Preserva a leitura vermelho/verde que a tela de extrato já tinha, agora
 * pelos tints do tema em vez de `error.light` / `success.light`.
 */
export default function ChipOperacao({ tipoOperacao }: Props) {
  const semantica =
    tipoOperacao === TipoOperacao.COMPRA ? "destructive" : "positive";

  return (
    <Chip
      label={tipoOperacao === TipoOperacao.COMPRA ? "Compra" : "Venda"}
      size="small"
      sx={(theme) => ({
        backgroundColor: theme.palette.statusChip[semantica].bg,
        color: theme.palette.statusChip[semantica].fg,
      })}
    />
  );
}
